/**
 * Dzieli zdanie na kawałki do układania (do czterech słów — każde osobno: "This | is | my | dog."; dłuższe po ok. dwa słowa: "I want | to eat | food."), zachowując wielkość liter
 * i interpunkcję. Kawałki w kolejności poprawnej — mieszanie robi sessionV2.ts.
 */
export function chunkSentence(text: string): string[] {
  const words = text.trim().split(/\s+/).filter(Boolean);
  const n = words.length;
  if (n <= 1) return words;
  const k = n <= 4 ? n : Math.min(4, Math.max(2, Math.round(n / 2))); // do czterech słów: każde słowo osobno (jak na makiecie), dłuższe zdania w kawałkach po ok. dwa słowa
  const base = Math.floor(n / k);
  const extra = n % k;
  const chunks: string[] = [];
  let pos = 0;
  for (let c = 0; c < k; c++) {
    const size = base + (c < extra ? 1 : 0);
    chunks.push(words.slice(pos, pos + size).join(' '));
    pos += size;
  }
  return chunks;
}
